import Vue from 'vue'
import request from '@/api/request.js';

// 订单列表
export const getOrderListPage = (data) => {
    return request({
        url: '/admin/order/adm/order/getListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 订单列表(内训报名订单)
export const getInternalOrderListPage = (data) => {
    return request({
        url: '/admin/order/adm/order/getInternalOrderListPage',
        method: 'post',
        type: 'json',
        data
    })
}

// 添加内训订单验收单
export const addInternalBill = (data) => {
    return request({
        url: '/order/adm/checkAccept/addInternalBill',
        method: 'post',
        type: 'json',
        data
    })
}

// 订单详情
export const getOrderDetail = (data) => {
    return request({
        url: '/admin/adm/order/getDetail',
        method: 'post',
        type: 'json',
        data
    })
}

// 订单详情
export const getAuditInfoByOrderId = (data) => {
    return request({
        url: '/order/adm/order/getAuditInfoByOrderId',
        method: 'post',
        type: 'json',
        data
    })
}

// 内训订单审核记录
export const getAuditLog = (data) => {
    return request({
        url: '/order/adm/internalTrainAudit/getAuditLog',
        method: 'post',
        type: 'json',
        data
    })
}

// 内训订单审核
export const auditInternalOrder = (data) => {
    return request({
        url: '/order/adm/internalTrainAudit/add',
        method: 'post',
        type: 'json',
        data
    })
}

// 审核订单
export const auditRemitOrder = (data) => {
    return request({
        url: '/order/adm/order/auditRemitOrder',
        method: 'post',
        type: 'json',
        data
    })
}

// 重新上传凭证
export const submitRemitVoucher = (data) => {
    return request({
        url: '/order/adm/order/submitRemitVoucher',
        method: 'post',
        type: 'json',
        data
    })
}

// 通过订单id查询发票信息
export const getInvoiceByOrderId = (data) => {
    return request({
        url: '/order/adm/invoice/getInvoiceByOrderId',
        method: 'post',
        type: 'json',
        data
    })
}

// 修改合同信息
export const updateContractById = (data) => {
    return request({
      url: '/order/adm/repairData/updateContractById',
        method: 'post',
        data
    })
}

// 租户列表
export const getSelectCompanyList = (params) => {
    return request({
        url: '/base/adm/company/getSelectCompanyList',
        method: 'get',
        params
    })
}

// 租户列表(筛选教务服务方/招生服务方)
export const getCompanyListByAgent = (params) => {
    return request({
      url: '/base/adm/company/getCompanyListByAgent',
        method: 'get',
        params
    })
}

// 获取讯飞状态集合
export const getIFlytekBalanceAuditList = () => {
  return request({
    url: '/order/adm/bill/getIFlytekBalanceAuditList',
    method: 'post',
    type: 'json'
  })
}


// 重新签协议
export const resignAgreement = (data) => {
  return request({
    url: '/order/adm/order/resignAgreement',
    method: 'post',
    type: 'json',
    data
  })
}

// 添加结算单
export const addBillOrder = (data) => {
  return request({
    url: '/order/adm/bill/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 添加验收单
export const addAcceptanceOrder = (data) => {
  return request({
    url: '/order/adm/acceptanceBill/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取易票联跳转路径
export const getYPLPayPath = data => {
  return request({
    url: 'order/app/order/yplPay',
    method: 'post',
    type: 'json',
    data
  })
}

// 获取结算单列表
export const pageByBillListPage = (data) => {
  let url = '/order/adm/bill/page'
  if (Vue.prototype.checkAdmin()) {
    url = '/order/adm/bill/pageByAdmin'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 结算单审核
export const billOrderAudit = (data) => {
  return request({
    url: '/order/adm/audit/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 关联订单
export const pageByBill = (data) => {
  let url = '/order/adm/order/pageByBill'
  if (data.isByOrder) {
    data.acceptanceId = data.id
    url = '/order/adm/acceptanceBill/pageByBill'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 结算单详情
export const getBillDetails = (data, next = false) => {
  let url = '/order/adm/bill/details'
  if (next) {
    if (Vue.prototype.checkAdmin()) {
      url = '/order/adm/bill/nextByAdmin'
    } else {
      url = '/order/adm/bill/next'
    }
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 上传发票物流信息
export const uploadInvoice = (data) => {
  return request({
    url: '/order/adm/bill/uploadInvoice',
    method: 'post',
    type: 'json',
    data
  })
}

// 上传银行回单
export const updateBankReceipt = (data) => {
  return request({
    url: '/order/adm/bill/updateBankReceipt',
    method: 'post',
    type: 'json',
    data
  })
}

// 提交验收单
export const addCheckAccept = (data) => {
  return request({
    url: '/order/adm/checkAccept/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 重新发起验收单
export const addAgainCheckAccept = (data) => {
  return request({
    url: '/order/adm/checkAccept/addAgain',
    method: 'post',
    type: 'json',
    data
  })
}


// 获取验收单列表
export const checkAcceptListPage = (data) => {
  let url = '/order/adm/checkAccept/page'
  if (Vue.prototype.checkAdmin()) {
    url = '/order/adm/checkAccept/pageByAdmin'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}
// 获取验收单列表 - 订单侧
export const checkAcceptByOrderListPage = (data) => {
  let url = '/order/adm/acceptanceBill/page'
  if (Vue.prototype.checkAdmin()) {
    url = '/order/adm/acceptanceBill/pageByAdmin'
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 验收单详情
export const getCheckAccept = (data, next = false) => {
  let url = '/order/adm/checkAccept/details'
  if (next) {
    if (Vue.prototype.checkAdmin()) {
      url = '/order/adm/checkAccept/nextByAdmin'
    } else {
      url = '/order/adm/checkAccept/next'
    }
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 验收单详情 - 订单侧
export const getCheckAcceptByOrder = (data, next = false) => {
  let url = '/order/adm/acceptanceBill/details'
  if (next) {
    if (Vue.prototype.checkAdmin()) {
      url = '/order/adm/acceptanceBill/nextByAdmin'
    } else {
      url = '/order/adm/acceptanceBill/next'
    }
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 验收单详情 - 订单侧
export const getCheckAcceptByOrderByOrderId = (data) => {
  return request({
    url: '/order/adm/acceptanceBill/detailsByOrderId',
    method: 'post',
    type: 'json',
    data
  })
}

// 验收单审核
export const checkAcceptAudit = (data) => {
  return request({
    url: '/order/adm/checkAcceptAudit/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 验收单审核 - 订单侧
export const acceptanceAudit = (data) => {
  return request({
    url: '/order/adm/acceptanceAudit/add',
    method: 'post',
    type: 'json',
    data
  })
}

// 招生结算单数据
export const billEnrollData = (data) => {
  return request({
    url: '/order/adm/bill/enrollData',
    method: 'post',
    type: 'json',
    data
  })
}

// 招生验收单数据
export const checkAcceptData = (data, isAgentFlag) => {
  let url = ''
  switch (isAgentFlag) {
    case 1:
      url = '/order/adm/checkAccept/checkAcceptData'
      break
    case 2:
      url = '/order/adm/checkAccept/agentCheckAcceptData'
      break
    default:
      url = '/order/adm/checkAccept/checkAcceptData'
      break
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 招生验收单数据 - 订单侧
export const checkAcceptDataByOrder = (data, isAgentFlag) => {
  let url = ''
  switch (isAgentFlag) {
    case 1:
      url = '/order/adm/acceptanceBill/acceptanceData'
      break
    case 2:
      url = '/order/adm/acceptanceBill/agentAcceptanceData'
      break
    default:
      url = '/order/adm/acceptanceBill/acceptanceData'
      break
  }
  return request({
    url,
    method: 'post',
    type: 'json',
    data
  })
}

// 更新结算单结算金额
export const updateBillBalanceData = (data) => {
  return request({
    url: '/order/adm/bill/updateBillBalanceData',
    method: 'post',
    type: 'json',
    data
  })
}

// 更新结算单结算金额
export const updateBondAmountData = (data) => {
  return request({
    url: '/order/adm/checkAccept/updateBondAmountData',
    method: 'post',
    type: 'json',
    data
  })
}

// 参训材料
export const getUserMaterials = (data) => {
  return request({
    url: '/order/adm/order/getUserMaterialsByOrderId',
    method: 'post',
    type: 'json',
    data
  })
}

// 参训材料审核
export const userMaterialsAudit = (data) => {
  return request({
    url: '/order/adm/order/userMaterialsAudit',
    method: 'post',
    type: 'json',
    data
  })
}

// 参训材料审核记录日志
export const userMaterialsAuditList = (data) => {
  return request({
    url: '/order/adm/order/userMaterialsAuditPage',
    method: 'post',
    type: 'json',
    data
  })
}

// 参训材料分页列表
export const userMaterialsPage = (data) => {
  return request({
    url: '/order/adm/order/userMaterialsPage',
    method: 'post',
    type: 'json',
    data
  })
}

// 修改订单验收状态
export const updateAcceptanceData = (data) => {
  return request({
    url: '/order/adm/acceptanceBill/updateAcceptanceData',
    method: 'post',
    data
  })
}

// 修改订单验收状态记录列表
export const getOrderUpdateRecord = (data) => {
  return request({
    url: '/order/adm/acceptanceBill/getOrderUpdateRecord',
    method: 'post',
    data
  })
}
